import styled from '@emotion/styled';
import { ThumbnailPictureByOrientation as ThumbnailPictureByOrientationComponent } from '@embed/components/common/ThumbnailPictureByOrientation';
export const ThumbnailContainer = styled('div') `
  box-sizing: border-box;
  border: none;
  box-sizing: border-box;
  color: currentColor;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  opacity: 1;
  position: relative;
  text-align: initial;
  text-decoration: none;
  width: 100%;
  z-index: 1;

  &:hover {
    color: inherit;
    filter: contrast(115%);
    text-decoration: none;
    z-index: 1;
  }
`;
const ThumbnailOverlay = styled.div `
  align-items: center;
  backdrop-filter: blur(10px);
  background: rgb(0 0 0 / 50%);
  border-radius: var(--border-radius);
  color: rgb(255 255 255 / 50%);
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: center;
  position: absolute;
  text-align: center;
  overflow: hidden;
`;
export const PlayingInPIPOverlay = styled(ThumbnailOverlay) `
  z-index: 3;
`;
export const HostWillBeRightBackOverlay = styled(ThumbnailOverlay) `
  z-index: 1;
`;
export const ThumbnailPictureByOrientation = styled(ThumbnailPictureByOrientationComponent) `
  height: 100% !important;
  margin: 0 !important;
  object-fit: var(--thumbnail-object-fit, cover) !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  -webkit-transform: translate3d(0, 0, 0);
`;
